import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/components/customer/home/footer/Footer.css";
import WorkerRegister from '../../../../components/serviceprovider/workerauth/WorkerAuth';
 import FeedbackButton from '../../../../components/customer/home/footer/feedback/FeedBack';

import {
  Facebook, Twitter, Instagram, Linkedin, Youtube,
  MapPin, Phone, Mail, Send, CheckCircle
} from "lucide-react";

// ── Navigation Routes ──
const QUICK_LINKS = [
  { label: "Home", path: "/" },
  { label: "Categories", path: "/services" },
  { label: "Blogs", path: "/blogs" },
];

const COMPANY = [
  { label: "About Us", path: "/about-us" },

  { label: "Terms & Conditions", path: "/terms-conditions" },
  { label: "Privacy Policy", path: "/privacy-policy" },
];

const SUPPORT = [
  { label: "FAQs", path: "/faqs" },
  { label: "Become a Responder", action: "WorkerRegister" },
];

const SOCIAL = [
  { icon: <Facebook size={14} />, label: "Facebook", url: "https://facebook.com" },
  { icon: <Twitter size={14} />, label: "Twitter", url: "https://twitter.com" },
  { icon: <Instagram size={14} />, label: "Instagram", url: "https://instagram.com" },
  { icon: <Linkedin size={14} />, label: "LinkedIn", url: "https://linkedin.com" },
  { icon: <Youtube size={14} />, label: "YouTube", url: "https://youtube.com" },
];

const CONTACT = [
  { icon: <MapPin size={14} />, cls: "ft-ci--pin", text: "Portland, USA" },
  { icon: <Phone size={14} />, cls: "ft-ci--phone", text: "+92 300 1234567" },
  { icon: <Mail size={14} />, cls: "ft-ci--mail", text: "Customercare@picks4tips.com" },
];

const Myfooter = () => {
  const navigate = useNavigate();

  // ── Subscribe State ──
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState(false);

  // ── Modal States ──
  const [showWorkerModal, setShowWorkerModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleSubscribe = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim() || !emailRegex.test(email)) {
      setError(true);
      setTimeout(() => setError(false), 2500);
      return;
    }
    setSubscribed(true);
    setEmail("");
  };

  return (
    <>
        <footer className="ft-root"></footer>
    <footer className="ft-root">
      {/* ── Newsletter Strip ── */}
      {/* <div className="ft-newsletter">
        <div className="ft-newsletter__left">
          <h4 className="ft-newsletter__heading">Stay Updated with WorkHub</h4>
          <p className="ft-newsletter__sub">Get the latest updates on new services and exclusive offers.</p>
        </div>

        {subscribed ? (
          <div className="ft-newsletter__success">
            <CheckCircle size={18} className="ft-newsletter__success-icon" />
            <span>You're subscribed! Thank you.</span>
          </div>
        ) : (
          <div className="ft-newsletter__form-wrap">
            <div className={`ft-newsletter__form ${error ? "ft-newsletter__form--error" : ""}`}>
              <input
                className="ft-newsletter__input"
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubscribe()}
              />
              <button className="ft-newsletter__btn" onClick={handleSubscribe}>
                Subscribe <Send size={13} />
              </button>
            </div>
            {error && <p className="ft-newsletter__error">Please enter a valid email address.</p>}
          </div>
        )}
      </div> */}

      {/* ── Divider ── */}
      <div className="ft-divider" />

      {/* ── Main Body ── */}
      <div className="ft-body">
        <div className="ft-grid">
          {/* Brand */}
          <div className="ft-brand">
            <div
              className="ft-brand__logo"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              <div className="ft-brand__icon">P4T</div>
              <h4 className="ft-brand__name">Picks4Tips</h4>
            </div>
            <p className="ft-brand__desc">
              USA's #1 marketplace for trusted home services. Connecting skilled
              professionals with seekers for quality service delivery.
            </p>
            <div className="ft-social">
              {SOCIAL.map((s) => (
                <button
                  key={s.label}
                  className="ft-social__btn"
                  aria-label={s.label}
                  onClick={() => window.open(s.url, "_blank")}
                >
                  {s.icon}
                </button>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="ft-col">
            <h5 className="ft-col__head">Quick Links</h5>
            <ul className="ft-col__list">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <button className="ft-col__link" onClick={() => navigate(l.path)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="ft-col">
            <h5 className="ft-col__head">Company</h5>
            <ul className="ft-col__list">
              {COMPANY.map((l) => (
                <li key={l.label}>
                  <button className="ft-col__link" onClick={() => navigate(l.path)}>
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Get In Touch + Support */}
          <div className="ft-col ft-col--last">
            <div>
              <h5 className="ft-col__head">Get In Touch</h5>
              <ul className="ft-contact">
                {CONTACT.map((c) => (
                  <li key={c.text} className="ft-contact__item">
                    <span className={`ft-contact__icon ${c.cls}`}>{c.icon}</span>
                    <span>{c.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="ft-col__support">
              <h5 className="ft-col__head">Support</h5>
              <ul className="ft-col__list">
                {SUPPORT.map((l) => (
                  <li key={l.label}>
                    <button
                      className="ft-col__link"
                      onClick={() =>
                        l.action === "WorkerRegister"
                          ? setShowWorkerModal(true)
                          : navigate(l.path)
                      }
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Worker Register Modal */}
            {showWorkerModal && (
              <WorkerRegister
                onClose={() => setShowWorkerModal(false)}
                onSwitchToLogin={() => {
                  setShowWorkerModal(false);
                  setShowLoginModal(true);
                }}
              />
            )}

          </div>
        </div>
      </div>

      {/* ── Bottom Bar ── */}
      <div className="ft-bottom">
        <span className="ft-bottom__copy">© 2026 Picks4Tips. All rights reserved.</span>
      </div>
   

        </footer>

    
  </>

  );
};

export default Myfooter;